import { css } from '@emotion/react';
import { EditableStatusChip } from '@frontend/appointment-status';
import { ExtendedAppointment } from '@frontend/schedule-helpers';
import { theme } from '@frontend/theme';
import { useEventCardStatusChip } from '../../hooks/use-event-card-status-chip';
import { AppointmentStatusV2 } from './appointment-event-card/appointment-status-v2';

type EventCardStatusChipProps = {
  locationId: string;
  eventId: string;
  appointmentDetails: ExtendedAppointment;
  appointmentInfoStatus: string | undefined;
};

export const EventCardStatusChip = ({
  locationId,
  eventId,
  appointmentDetails,
  appointmentInfoStatus,
}: EventCardStatusChipProps) => {
  const {
    selectedStatus,
    isLoadingIntegrationDetails,
    isIntegratedOffice,
    isScheduleV3FlagEnabled,
    updateApptStatusMutation,
    writebackApptStatusMutation,
    handleStatusChange,
  } = useEventCardStatusChip({ locationId, eventId, appointmentDetails, appointmentInfoStatus });

  if (!locationId || !appointmentDetails.id) {
    return null;
  }

  const statusChipProps = {
    status: selectedStatus,
    isIconOnly: true,
    bordered: true,
    darkModeMenu: true,
    disabled: isLoadingIntegrationDetails,
    isLoading: updateApptStatusMutation.isLoading || writebackApptStatusMutation.isLoading,
    css: { height: 16, width: 20 },
    wrapperStyle: [statusChipsWrapperStyle],
  };

  return isScheduleV3FlagEnabled ? (
    <EditableStatusChip
      {...statusChipProps}
      appointmentDetails={appointmentDetails}
      disabled={statusChipProps.disabled}
      isIntegrated={isIntegratedOffice}
      onStatusChange={handleStatusChange}
    />
  ) : (
    <AppointmentStatusV2 {...statusChipProps} locationId={locationId} appointmentId={appointmentDetails.id} />
  );
};

const statusChipsWrapperStyle = css({
  '&:hover > .chip': {
    outline: `2px solid ${theme.colors.primary50}`,
    outlineOffset: 1,
  },
});
